import React from 'react';
import { Users } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { readCompanyDefaults } from '../../hooks/useCompanyDefaults';

// "via Team X" chip for workers: shown when the job reached them through their
// team (not a direct assignment). Hidden for admins/supervisors and when the
// company turned the badge off in Company Defaults.
export const TeamViaBadge = ({ job, className = '' }) => {
  const { user, isAdmin } = useAuth();
  if (!job || !user || isAdmin) return null;
  if (!readCompanyDefaults().jobs_show_team_badge) return null;
  if (!job.assigned_team_id || job.assigned_to === user.id) return null;
  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold ${className}`}
      style={{ background: 'rgba(167,139,250,0.15)', color: '#C4B5FD', border: '1px solid rgba(167,139,250,0.4)' }}
      title="This job is on your list because it is assigned to your team"
      data-testid={`team-via-badge-${job.id}`}
    >
      <Users className="w-3 h-3" />
      Team{job.team_name ? `: ${job.team_name}` : ''}
    </span>
  );
};
